import { combineEpics } from 'redux-observable'

export const LOCALSTORAGE_NOTIFICATIONS_SETTINGS = 'notifications_settings'
export const GEOLOCATION_SETTINGS = 'geolocation_board_settings'

// Actions
export const RETRIEVE_SETTINGS_REQUEST = 'notifications/RETRIEVE_SETTINGS_REQUEST'
export const RETRIEVE_SETTINGS_SUCCESS = 'notifications/RETRIEVE_SETTINGS_SUCCESS'
export const RETRIEVE_SETTINGS_FAILURE = 'notifications/RETRIEVE_SETTINGS_FAILURE'
export const STORE_SETTINGS_REQUEST = 'notifications/STORE_SETTINGS_REQUEST'
export const STORE_SETTINGS_SUCCESS = 'notifications/STORE_SETTINGS_SUCCESS'

const data = localStorage.getItem(LOCALSTORAGE_NOTIFICATIONS_SETTINGS)
const geolocationSettingsData = localStorage.getItem(GEOLOCATION_SETTINGS)
// Reducer
const INITIAL_STATE = {
  loading: false,
  settings: data ? JSON.parse(data) : {},
  geolocationSettings: geolocationSettingsData ? JSON.parse(geolocationSettingsData) : {},
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case RETRIEVE_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case RETRIEVE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: true,
        settings: action.payload,
      }
    case RETRIEVE_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
      }
    case STORE_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case STORE_SETTINGS_SUCCESS:
      const settingsKey =
        action.payload.storageKey === LOCALSTORAGE_NOTIFICATIONS_SETTINGS ? 'settings' : 'geolocationSettings'
      return {
        ...state,
        loading: false,
        [settingsKey]: action.payload.settings,
      }
    default:
      return state
  }
}

// Actions Creators
export const retrieveSettingsRequest = (payload) => ({
  type: RETRIEVE_SETTINGS_REQUEST,
  payload,
})

export const retrieveSettingsSuccess = (payload) => ({
  type: RETRIEVE_SETTINGS_SUCCESS,
  payload,
})

export const retrieveSettingsFailure = () => ({
  type: RETRIEVE_SETTINGS_FAILURE,
})

export const storeSettingsRequest = (payload) => ({
  type: STORE_SETTINGS_REQUEST,
  payload: payload,
})

export const storeSettingsSuccess = (payload) => ({
  type: STORE_SETTINGS_SUCCESS,
  payload: payload,
})

// Epics
export const epic = combineEpics(retrieveNotificationSettings, storeNotificationSettings)

export function retrieveNotificationSettings(action$) {
  return action$.ofType(RETRIEVE_SETTINGS_REQUEST).map((action) => {
    const data = localStorage.getItem(action.payload)
    if (data) return retrieveSettingsSuccess(JSON.parse(data))
    else return retrieveSettingsFailure()
  })
}

export function storeNotificationSettings(action$) {
  return action$.ofType(STORE_SETTINGS_REQUEST).map((action) => {
    const data = JSON.stringify(action.payload.settings)
    localStorage.setItem(action.payload.storageKey, data)
    return storeSettingsSuccess(action.payload)
  })
}
